__turbopack_context__.v({
  "date": "gw9HVG_date",
  "header": "gw9HVG_header",
  "intro": "gw9HVG_intro",
  "item": "gw9HVG_item",
  "list": "gw9HVG_list",
  "log": "gw9HVG_log",
  "page": "gw9HVG_page",
  "tag": "gw9HVG_tag",
  "text": "gw9HVG_text",
  "toolbar": "gw9HVG_toolbar",
  "upcoming": "gw9HVG_upcoming" + " " + __turbopack_context__.i(262643)["brandchip"],
  "yearLink": "gw9HVG_yearLink",
  "years": "gw9HVG_years",
  "yearsList": "gw9HVG_yearsList",
});
